<!-- Main content column: all rows stack vertically -->
<div class="flex flex-1 min-w-0 flex-col gap-0.5">

  <!-- Row 1: name + status badge + quantity + price + actions, all inline -->
  <div class="flex  items-center gap-2 min-w-0">
    <!-- Status dot — mt-1 nudges it into visual alignment with the first text row -->
    <elcia-dot
      [color]="product().isActive ? 'var(--p-green-500)' : 'var(--p-surface-400)'"
      aria-hidden="true"
      class="mt-1 shrink-0"/>
    <!-- Product name — takes remaining space, truncates on overflow -->
    <span class="font-semibold truncate flex-1 min-w-0 leading-snug">{{ product().productName }}</span>

    <!-- Licence server chip — shown when the product is attached to a server -->
    @if (product().licenceServerName; as serverName) {
      <span
        [title]="'product-customer.assigned-to-server' | translate"
        class="inline-flex items-center gap-1 text-xs bg-[var(--p-surface-100)] text-surface-600 border border-surface-200 rounded-full py-0.5 px-2.5 whitespace-nowrap shrink-0 leading-none">
        <span aria-hidden="true" class="pi pi-server text-[0.65rem]"></span>
        {{ serverName }}
      </span>
    }

    <!-- Unassigned highlight — recurring, active, no server yet: red to flag it needs attaching -->
    @if (showUnassignedWarning()) {
      <span
        class="inline-flex items-center gap-1 text-xs bg-red-50 text-red-600 border border-red-200 rounded-full py-0.5 px-2.5 whitespace-nowrap shrink-0 leading-none">
        <span aria-hidden="true" class="pi pi-exclamation-triangle text-[0.65rem]"></span>
        {{ 'product-customer.not-assigned-to-server' | translate }}
      </span>
    }

    <!-- Quantity — compact ×N inline format -->
    <span class="text-sm text-surface-500 tabular-nums shrink-0"
          data-testid="customer-product-quantity">&times;{{ product().quantity }}</span>

    <!-- Unit price agreed with the customer -->
    <span *canAccessFinances class="text-sm text-surface-500 tabular-nums shrink-0"
          data-testid="customer-product-price">{{ product().price | number:'1.2-2' }} €</span>

    <!-- Action buttons — text variant for minimal visual weight; tooltips for accessibility -->
    <div class="flex items-center gap-0.5 shrink-0">
      <elcia-button
        (onClick)="edit()"
        [icon]="'edit'"
        [severity]="'secondary'"
        [tooltip]="'action.edit' | translate"
        [variant]="'text'"
        data-testid="customer-product-edit"/>
      <elcia-button
        (onClick)="delete()"
        [icon]="'delete'"
        [severity]="'danger'"
        [tooltip]="'action.delete' | translate"
        [variant]="'text'"/>
    </div>
  </div>

  <!-- Row 2: period — one-shot shows start date only; recurring shows start → end -->
  <div class="flex items-center gap-1.5 text-xs text-surface-400">
    @if (isOneShot()) {
      @if (product().startDate) {
        <span class="whitespace-nowrap tabular-nums">{{ product().startDate | date:'dd/MM/yyyy' }}</span>
      }
    } @else {
      <span class="whitespace-nowrap tabular-nums">{{ product().startDate | date:'dd/MM/yyyy' }}</span>
      <span class="text-surface-300">&rarr;</span>
      <span class="whitespace-nowrap tabular-nums">{{ product().endDate | date:'dd/MM/yyyy' }}</span>
    }
  </div>

  <!-- Row 3: description — italic for visual distinction from the name -->
  @if (product().description) {
    <span class="text-xs text-surface-500 italic leading-snug line-clamp-2">{{ product().description }}</span>
  }

  <!-- Row 4: extra features sub-list, indented with a left border -->
  @if (product().extraFeatures.length > 0) {
    <div class="flex flex-col gap-0.5 mt-1 pl-3 border-l-2 border-primary-50">
      @for (feature of product().extraFeatures; track feature.id) {
        <span class="text-xs text-surface-400 truncate">
          {{ feature.productName }}
          <span class="tabular-nums">&times; {{ feature.quantity }}</span>
          <span *canAccessFinances class="tabular-nums"> · {{ feature.price | number:'1.2-2' }} €</span>
        </span>
      }
    </div>
  }

</div>
